//
// Reserve the sortableTables object
window.duo.sortableTables = {};
window.duo.sortableTables.update = (sortableTableUuid, sorting = undefined) => {
	let table = $(document).find(`table[data-sortable-table-uuid="${sortableTableUuid}"]`);

	let tableData = {};
	$(table).find('tbody tr').each((rowId, row) => {
		let rowData = {};
		$(row).find('td').each((descriptionId, description) => {
			if ($(description).attr('sortable') == 'false') {
				rowData[descriptionId] = null;
				return;
			}

			if ($(description).get(0).hasAttribute('sortable-value')) {
				rowData[descriptionId] = $(description).attr('sortable-value');
				return;
			}

			rowData[descriptionId] = $(description).text();
		});
		tableData[rowId] = rowData;
	});
	duo.sortableTables[sortableTableUuid] = tableData;
};

window.duo.sortableTables.sort = (sortableTableUuid, ascending, column) => {
	let columnData	= [];
	let sortedRows	= [];

	for (index in duo.sortableTables[sortableTableUuid]) {
		columnData.push({
			index:	parseInt(index),
			data:	duo.sortableTables[sortableTableUuid][index][column]
		});
	}

	columnData = columnData.sort((firstItem, secondItem) => {
		let a = firstItem.data;
		let b = secondItem.data;

		if (!isNaN(a) && a !== null) {
			a = parseInt(a);
		}

		if (!isNaN(b) & b !== null) {
			b = parseInt(b);
		}

		if (a == null) {
			a = '';
		}
		if (b == null) {
			b = '';
		}

		if (ascending) {
			return a < b ? -1 : (a > b ? 1 : 0);
		} else {
			return a > b ? -1 : (a < b ? 1 : 0);
		}
	});

	let table = $(document).find(`table[data-sortable-table-uuid="${sortableTableUuid}"]`);
	sortedRows = columnData.map(item => {
		return $(table).find('tbody tr').eq(item.index).get(0);
	}).reverse();

	sortedRows.forEach(row => {
		$(table).prepend(row);
	});
};

$(document).ready(function () {

	$('table.table--sortable').each((tableId, table) => {

		//
		// Append the table to the sortableTables dataset
		let sortableTableUuid = $(table).attr('data-sortable-table-uuid');

		//
		// Initial sort if a setting exists
		const sortableStore = `sortable-${ $(table).attr('sortable-store') }`;
		const sortableData = sessionStorage.getItem(sortableStore);
		if (sortableData) {
			const { headId, direction } = JSON.parse(sortableData);

			if (headId) {
				$(table).find('thead th').removeClass('sort-asc sort-desc');
				$(table).find(`thead th:nth(${ headId })`).addClass(direction);

				duo.sortableTables.update(sortableTableUuid);
				duo.sortableTables.sort(sortableTableUuid, direction == 'sort-asc', headId);
			}
		}

		$(table).on('click', 'thead th:not(.options):not([sortable="false"])', function (event) {
			let sortDirection = $(this).hasClass('sort-asc') ? 'sort-desc' : 'sort-asc';
			$(table).find('thead th').removeClass('sort-asc sort-desc');
			$(this).addClass(sortDirection);

			//
			// Find the headId that was clicked
			let clickedHead = this;
			$(table).find('thead th').each((headId, head) => {
				if (head.isSameNode(clickedHead)) {
					sessionStorage.setItem(sortableStore, JSON.stringify({
						headId: headId,
						direction: sortDirection
					}));

					duo.sortableTables.update(sortableTableUuid);
					duo.sortableTables.sort(sortableTableUuid, sortDirection == 'sort-asc', headId);
				}
			})
		});
	});
})
